module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-new-edit-icon-active.525d4715.svg";